import "./footer.scss";

const Footer = ({ configs }) => {
  return (
    <div className="footer">
      {/* <div className="footer-container">
        <div className="location footer-item">
          <iframe
            title="myframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3236.0150824012567!2d51.44411238898639!3d35.79956305269645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e05c6e05d564f%3A0x11254ccddcea8b90!2sMojtahedi%20Exchange!5e0!3m2!1sen!2sus!4v1702280576397!5m2!1sen!2sus"
          ></iframe>
        </div>
        <div className="info footer-item">
          <div className="info-item">آدرس: {configs.address}</div>
          <div className="info-item">
            تلفن: <span className="ltr">&#x200E;{configs.fax}</span>
          </div>
          <div className="info-item">ایمیل: {configs.email}</div>
        </div>
        <div className="vertical-lr"></div>
        <div className="social footer-item">
          <div className="desc footer-item">
            <div>ما را در شبکه های اجتماعی دنبال کنید</div>
          </div>
          <div>
            <a href={`https://instagram.com/${configs?.instagram}`}>
              <img alt="social" src={instaIcon} />
            </a>
            <a href={`https://t.me/${configs?.telegram}`}>
              <img alt="social" src={telIcon} />
            </a>
            <a href={configs.whatsApp}>
              <img alt="social" src={whatsIcon} />
            </a>
          </div>
        </div>
      </div> */}
      <div className="mini-footer">
        <div className="mini-item">
          طراحی شده توسط گروه <a href="https://telmis.ir/">تلمیس</a>
        </div>
        <div className="mini-item">
          کلیه حقوق مادی و معنوی این وبسایت متعلق به صرافی نصرالهی می باشد و کپی
          برداری از آن پیگرد قانونی دارد.
        </div>
      </div>
    </div>
  );
};
export default Footer;
